import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import VueMeta from 'vue-meta'
import axios from './axios'
import edunix, { $localStorage } from './plugins/edunix'

Vue.use(VueMeta)

Vue.config.productionTip = false;

location.search.slice(1).split('&').filter(Boolean).forEach(item => {
	const [key, value] = item.split('=');
	router.currentRoute.query[key] = value;
});

if (
	!router.currentRoute.query.userName ||
	!router.currentRoute.query.password ||
	!router.currentRoute.query.centerId
) {
	if ('auth' in localStorage) {
		try {
			const auth = JSON.parse(localStorage.getItem('auth'));
			store.state.auth.authenticated = true;
			store.state.auth.user = auth;
			axios.defaults.headers.common['x-password'] = $localStorage.password;
			store.dispatch('companyInfo/fetchAll');
		} catch (e) {
			router.replace({ name: 'login' });
			store.dispatch('auth/logout');
		}
	} else {
		router.replace({ name: 'login' });
	}
}

new Vue({
	router,
	store,
	vuetify,
	edunix,
	i18n,
	render: h => h(App)
}).$mount('#app')